import { h } from "omi";

import { IconProps } from "@/components";

export function MarkdownIcon({ width, height }: IconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.34567 5H8.44567V11.5333H6.99317L7.048 6.22383L5.27467 11.5333H4.07183L2.267 6.22383C2.30667 6.86667 2.3265 11.5333 2.3265 11.5333H1V5H3.156C3.156 5 4.68433 9.49283 4.73333 9.80667L6.34567 5ZM13.0552 8.61667V5.11667H11.1115V8.61667H9.16667L12.0833 11.5333L15 8.61667H13.0552Z"
        fill="currentColor"
      />
    </svg>
  );
}
